/* eslint-disable s4l/require-i18n-formatmessage-id-literal */
import React from 'react'

import { BottomSheet, Typography } from '@s4l/ds'
import { useS4LContext } from '@s4l/react-context'
import type { Board } from '@s4l/stayforlong/booking/Board'

interface IBoardInfo {
  model: Board
}

function BoardInfo({ model }: Readonly<IBoardInfo>) {
  const { i18n } = useS4LContext()

  const name = model.name()
  const description = model.description()

  if (!name || !description) return null

  return (
    <BottomSheet.Content
      title={i18n.formatMessage({ id: 'filter-category.meal-plan' })}
      modalOnDesktop
      size="s"
    >
      <div>
        <Typography variant="body" size="l" bold as="h5">
          {i18n.formatMessage({ id: name })}
        </Typography>

        <Typography variant="caption" size="l" as="p">
          {i18n.formatMessage({ id: description })}
        </Typography>
      </div>
    </BottomSheet.Content>
  )
}

BoardInfo.displayName = 'RoomConfigurator.Form.Info.BoardInfo'

export default BoardInfo
